import { render } from "./SelectPurchaseType.vue?vue&type=template&id=43799c04&ts=true"
import script from "./SelectPurchaseType.vue?vue&type=script&lang=ts"
export * from "./SelectPurchaseType.vue?vue&type=script&lang=ts"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__